<template>
    <div class="bg_index">
        <!--banner-->
        <div class="w100 cpfa"></div>

        <div class="sound-meeting"></div>



        <!-- 商务合作 -->
        <cooperateForm class="submitform" id="submit"></cooperateForm>
        <div class="footblack" />
    </div>
</template>
  
<script>
import cooperateForm from '@/components/common/cooperateForm'
import suitCase from '@/components/common/suitCase'
import TechnicalHighlights from '@/components/common/TechnicalHighlights'
import coreCard from '@/components/common/coreCard'
import productDownload from '@/components/common/productDownload'
// import { BaseURL } from '@/api/http.js'
export default {
    data() {
        return {

        }
    },
    methods: {
    },
    components: {
        cooperateForm: cooperateForm,
        TechnicalHighlights,
        suitCase: suitCase,
        coreCard,
        productDownload
    }
}
</script>
  
<style scoped>
/* 技术优势 */
.Technical {
    background-color: white;
}

.cpfa {
    width: 100%;
    background: rgb(28, 19, 39);
    height: 95px;
    margin-top: -61px;
    /* margin-bottom: 20px; */
}

.sound-meeting {
    background: url(../../../../assets/images/rs/soundMeeting.png) no-repeat;
    height: 3490px;
    width: 1250px;
    background-size: contain;
}

.submitform {
    width: 803px;
    margin-top: 75px;
    margin-bottom: -23px;
}

.footblack {
    height: 50px;
    width: 100%;
    background: rgba(248, 248, 248, 1);
}

/* 产品亮点 */
.other {
    margin: 0 auto;
    width: 1250px;
    height: 650px;
}

.other>div {
    float: left;
    margin-left: 38px;
    margin-top: 35px;
}

.other /deep/ .app {
    height: 520px;
}

.other /deep/ .title {
    height: 290px;
}

.bg_index {
    background-color: #fff;
}

/* .suitcase.cjapply[data-v-eea495be] {
      background-size: 100% 100%;
      width: 366px;
      height: 264px;
      padding-top: 105px;
      margin: 0;
  } */
.suitcase /deep/ .cjapply {
    width: 526px;
}

.suitcase /deep/ #cj {
    width: 1200px;
}

.suitcase1 {
    margin-bottom: 80px;
}

.bannerFather /deep/ .caiye {
    margin-top: 50px;
}

.bannerFather /deep/ .product-h2 {
    width: 130%;
}

.bannerFather /deep/ .desc {
    width: 130%;
    margin-top: 25px;
}

.bannerFather /deep/ .product-p {
    margin-top: 105px;
}

.bannerFather /deep/ .brand {
    margin-top: -42px;
}
</style>
  


// WEBPACK FOOTER //
// src/components/pages/solution/Hs/SoundMeeting.vue